var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AgencySort } from '@/ui/modules/agency/constants';
export var readEnabledAgencies = {
    read: function (_, _a) {
        var readField = _a.readField;
        var agenciesRef = readField('readAgencies');
        var agencies = agenciesRef
            .map(function (ref) { return (__assign(__assign({}, ref), { name: readField('name', ref), last_activity: readField('last_activity', ref), created_at: readField('created_at', ref), enabled: readField('enabled', ref) })); })
            .sort(AgencySort().method)
            .filter(function (_a) {
            var enabled = _a.enabled;
            return enabled;
        });
        return agencies;
    },
};
